export default "__VITE_ASSET__603c6714__"